export const common = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
        logoutIsSuccessful:'Logout is successfull',
        pleaseLoginToContinue:'Please login to continue',
        delete_message:'Are you sure you want to delete this record?',
        loginConfrimMessage:"You are already logged-in on another device. To logout and login here click ok",
        ok:'OK',
        cancel:'Cancel',
        delete:'Delete',
        edit:'Edit',
        yes: 'Yes',
        no: 'No',
        samplefile:'Sample file',
        norecord: 'No records exist',
        processFail: 'Unable to process the request. Please try again',
        download_bulk:"Please select Customer and Project",
        download_bulk1:"Please select Project",
        error:{
            loginfail: 'Unable to login. Please try again',
            processfail: 'Unable to process the request. Please try again',
        },
        remove:{
            error: 'Unable to delete the record. Please try again',
            confirm_message: 'Are you sure you want to delete this',
            confirm_message1: 'Are you sure you want to continue?',
        },
        login:{
            fail: 'Unable to login. Please try again',
        },
        forgotpassword:{
            success: "Forgot password link has been sent to your mail"
        },
        resetpassword:{
            success: "Password has been changed successfully"
        },
        back_to_login: 'Back ',
        back_to_sign_in: 'Back ',
        select: 'Select',
        active: 'Active',
        inactive: 'Inactive',
        save: 'Save',
        no_permission: 'You do not have permission to do this operation',
        search: 'Search',
        submit:'Submit',
        reset:'Reset',
        ok:'Ok',
        action:'Action',
        processing:'Processing',
        sample_file_download:'Sample File Download',
        download : 'Download',
        upload:'Upload',
        bulk_upload:'Bulk Upload',
        no_data:'No data',
        created_date_time:'Created Date & Time',
        modified_date_time:'Modified Date & Time',
        download_sample_file:'Download Sample File',
        personal_information:'Personal Information',
        address_information:'Address Information',
        back_btn:'Back',
        first:"First",
        last:"Last",
        add_btn:'+',
        del_btn:'-',
        hierarchy_bulk_upload:"hierarchy_bulk_upload",
       login_msg: "Please login to continue.",
       failed_to_fetch:"Failed to fetch",
       accept:"Accept",
       cancel:"Cancel"
    },

    ar: {
        logoutIsSuccessful:'تم تسجيل الخروج بنجاح',
        pleaseLoginToContinue:'الرجاء تسجيل الدخول للمتابعة',
        delete_message:'هل أنت متأكد من رغبتك في حذف التسجيل؟',
        loginConfrimMessage:'لقد قمت بتسجيل الدخول بالفعل على جهاز آخر. لتسجيل الخروج وتسجيل الدخول هنا انقر فوق موافق',
        ok:'نعم',
        cancel:'إلغاء',
        delete:'حذف',
        edit:'تعديل',
        yes: 'نعم',
        no: 'لا',
        samplefile:'ملف عينة',
        norecord: 'لا توجد سجلات',
        processFail: 'غير قادر على معالجة الطلب. حاول مرة اخرى',
        download_bulk:"الرجاء تحديد العميل والمشروع",
        download_bulk1:"الرجاء تحديد المشروع",
        error:{
            loginfail: 'غير قادر على تسجيل الدخول. حاول مرة اخرى',
            processfail: 'غير قادر على معالجة الطلب. حاول مرة اخرى',
        },
        remove:{
            error: 'تعذر حذف السجل. حاول مرة اخرى',
            confirm_message: 'هل أنت متأكد من رغبتك في الحذف؟',
            confirm_message1: 'هل أنت متأكد أنك تريد الاستمرار؟',
        },
        login:{
            fail: 'غير قادر على تسجيل الدخول. حاول مرة اخرى',
        },
        forgotpassword:{
            success: "تم إرسال رابط نسيت كلمة المرور إلى بريدك"
        },
        resetpassword:{
            success: "تم تغيير كلمة المرور بنجاح"
        },
        back_to_login: 'عودة',
        back_to_sign_in: 'عودة ',
        select: 'اختيار',
        active: 'نشط',
        inactive: 'غير نشط',
        save: 'حفظ',
        no_permission: 'ليس لديك إذن للقيام بهذه العملية',
        search: 'بحث',
        submit:'إرسال',
        reset:'إعادة ضبط',
        ok:'نعم',
        action:'عمل',
        processing:'معالجة',
        sample_file_download:'تنزيل نموذج ملف',
        download : 'تنزيل',
        upload:'رفع',
        bulk_upload:'رفع مجمع',
        no_data:'لايوجد بيانات',
        created_date_time:'تاريخ الإنشاء والوقت',
        modified_date_time:'التاريخ والوقت المعدل',
        download_sample_file:'تنزيل نموذج ملف',
        personal_information:'معلومات شخصية',
        address_information:'معلومات العنوان',
        back_btn:'عودة',
        add_btn:'+',
        del_btn:'-',
        first:"أولا",
        last:"الاخير",
        hierarchy_bulk_upload:"تحميل مجمع هرمي",
        login_msg: "الرجاء تسجيل الدخول للمتابعة.",
        failed_to_fetch:"فشل في جلب",
        accept:"قبول",
       cancel:"يلغي"

    },
}